export const PERMISSIONS = {
  analytics_dashboard: { view: true, create: true, edit: true, delete: true },
  categories: { view: true, create: true, edit: true, delete: true },
  brand: { view: true, create: true, edit: true, delete: true },
  users: { view: true, create: true, edit: true, delete: true },
  products: { view: true, create: true, edit: true, delete: true },
  orders: { view: true, create: true, edit: true, delete: true },
  returns: { view: true, create: true, edit: true, delete: true },
  payments: { view: true, create: true, edit: true, delete: true },
  logs_tracking: { view: true, create: true, edit: true, delete: true },
  newsletter: { view: true, create: true, edit: true, delete: true },
  disputes: { view: true, create: true, edit: true, delete: true },
  queries: { view: true, create: true, edit: true, delete: true },
  cms: { view: true, create: true, edit: true, delete: true },
  notifications: { view: true, create: true, edit: true, delete: true },
  profile: { view: true, create: true, edit: true, delete: true },
  change_password: { view: true, create: true, edit: true, delete: true },
  staffs: { view: true, create: true, edit: true, delete: true },
  sizes: { view: true, create: true, edit: true, delete: true },
  bulk_upload: { view: true, create: true, edit: true, delete: true },
};
